export default __webpack_public_path__ + "static/media/dog-purple.411c40c9.svg";